import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import ChargesExploitation from '../Graph/EPFL/ChargesExploitation';
import { rescueHtml } from '../Components/Tools';

const Page43Graph = (props) => {
    const blue = '#069BD3';
    const smoothGrey = '#f4f4f4';
    
    // Calculer le nombre d'hypothèses affichées et ajuster la hauteur
    const visibleHypotheses = (props.affH1 ? 1 : 0) + (props.affH2 ? 1 : 0) + (props.affH3 ? 1 : 0);
    let graphHeight = 150; // défaut
    if (visibleHypotheses === 1) {
        graphHeight = 500;
    } else if (visibleHypotheses === 2) {
        graphHeight = 250;
    } else if (visibleHypotheses === 3) {
        graphHeight = 150;
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    <img style={{width: 200}} src={Logo} />
                </div>

                <div style={{flex: 1}}></div>
                
                <div style={{margin: 25}}>
                    <p style={{color: blue, fontSize: 24}}>{rescueHtml(props.user.nom_organisme)}</p>
                </div>
            </div>

            <div style={{borderBottom: '1px solid '+blue, marginLeft: 25}}>
                <p style={{color: blue, fontSize: 26}}>{props.titre}</p>
            </div>


            {/* Container */}
            <div style={{flex: 1, marginTop: 10, display: 'flex', flexDirection: 'column'}}>
                {props.affH1 &&
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25, minHeight: 0}}>
                    <div style={{flex: 1, margin: 5, textAlign: 'left', display: 'flex', flexDirection: 'column'}} className='shadow-md rounded'>
                        <p style={{fontWeight: 'bold', color: blue}}>Hypothèse 1</p>
                        <ChargesExploitation user={props.user} hypothese={'h1'} download={false} height={graphHeight}/>
                    </div>
                </div>
                }
                {props.affH2 &&
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25, minHeight: 0}}>
                    <div style={{flex: 1, margin: 5, textAlign: 'left', display: 'flex', flexDirection: 'column'}} className='shadow-md rounded'>
                        <p style={{fontWeight: 'bold', color: blue}}>Hypothèse 2</p>
                        <ChargesExploitation user={props.user} hypothese={'h2'} download={false} height={graphHeight}/>
                    </div>
                </div>
                }
                {props.affH3 &&
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25, minHeight: 0}}>
                    <div style={{flex: 1, margin: 5, textAlign: 'left', display: 'flex', flexDirection: 'column'}} className='shadow-md rounded'>
                        <p style={{fontWeight: 'bold', color: blue}}>Hypothèse 3</p>
                        <ChargesExploitation user={props.user} hypothese={'h3'} download={false} height={graphHeight}/>
                    </div>
                </div>
                }
            </div>


            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
                <div style={{marginRight: 25}}>
                    <p style={{fontSize: 10}}>Page : {props.index}</p>
                </div>
            </div>
        </div>
    );
};

export default Page43Graph;
